module.exports = __webpack_public_path__ + "imgesssyaa/svg/puzzle.87ba894a.svg";